import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { InternshipListListingModel } from 'common/models/page-models/Student Internship List/Internship Table Model/internship-list.model';
import { InternshipFilterModel } from 'common/models/page-models/Student Internship List/Intership Filter Form/internship-list-filter-data.model';
import { InternshipFilterMetaModel } from 'common/models/page-models/Student Internship List/Intership Filter Form/internship-list-filter-meta.model';
import { UnassignInternshipModel } from 'common/models/page-models/Student Internship List/Unassign-Internship/unassign-internship-data.model';
import { UnassignInternshipMetaModel } from 'common/models/page-models/Student Internship List/Unassign-Internship/unassign-internship-meta.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { InternshipListGridWidgetService } from 'common/widget/intership Listing/intership-list-widget.service';


@Injectable({
    providedIn: 'root'
})
export class InternshipListsGridResolver extends GridResolver<InternshipFilterModel, InternshipListListingModel> {
    constructor(
        protected fs: InternshipListGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

        // console.log("Internship rsolved Called")
        
    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new InternshipFilterModel();
        return dataModel;
    }

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        transferData.filterData = new InternshipFilterModel();
        transferData.filterMeta = new InternshipFilterMetaModel().getMetaModel();
        transferData.formData = new UnassignInternshipModel();
        transferData.formMeta = new UnassignInternshipMetaModel().getMetaModel();
        transferData.recordPerPage = metaModel.properties?.recordPerPage;
        this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
 
}
